// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__e8MIg","errors":"Errors_errors__XCetj"};